type TLocale = 'en' | 'de' | 'fr' | 'nl';

const tExists = (translation: any) => {
    // TODO: expose exists method from i18n unified frontend runtime
    return typeof translation === 'string' &&
        !translation.startsWith('common.') &&
        !translation.startsWith('step_')
        ? translation
        : undefined;
};

export type { TLocale };
export { tExists };
